import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import Constants from '@/constants';
import { i18n } from '@/core/i18n';

import { Colors } from '@/core/helpers';
import { AppFooter, AppSkeleton } from './components';

@Component({
    data() {
        return {
            languages: Constants.i18n.LANGUAGES,
            loading: true,
            channelId: '',
            channelLoaded: false
        };
    },
    components: {
        AppFooter,
        AppSkeleton
    }
})
export default class App extends mixins(i18n.Mixins.Culture) {
    loading: boolean;
    channelId: string;
    channelLoaded: boolean;

    async created() {
        await this.importLanguage();
        this.loading = false;
    }

    mounted() {
        const { ref, ...options } = this.$route.query;

        if (ref?.length > 0 && Object.keys(options).length > 0) {
            Vue.$sessionStorage.setItem('order-url-parameters', JSON.stringify(this.$route.query));
        }

        const storedParameters = JSON.parse(Vue.$sessionStorage.getItem('order-url-parameters') || '{}');

        if (ref?.length > 0 && ref === storedParameters.ref && Object.keys(options).length === 0) {
            this.changeUrlParameters(storedParameters);
        }

        const color = this.$route.query.color as string;

        if (Colors.isHexColorValid(color)) {
            this.changePrimaryColor(color);
        }
    }

    loadFooter(id: string) {
        this.channelId = id;
        this.channelLoaded = true;
    }

    changeUrlParameters(parameters: any) {
        this.$router.push({ query: parameters });
    }

    changePrimaryColor(baseColor: string) {
        if (!baseColor) {
            return;
        }

        const root = document.documentElement;
        const hslaColor = Colors.convertHexToHSLA(baseColor);
        const convertedColor: Array<string> = hslaColor.split(',');

        root.style.setProperty('--colorPrimary-h', convertedColor[0]);
        root.style.setProperty('--colorPrimary-s', `${convertedColor[1]}%`);
        root.style.setProperty('--colorPrimary-l', `${convertedColor[2]}%`);
        root.style.setProperty('--colorPrimary-a', convertedColor[3]);

        const { red, green, blue } = Colors.convertHexToRGBA(baseColor);
        const o = Math.round((red * 299 + green * 587 + blue * 114) / 1000);

        if (o > 100) {
            root.style.setProperty('--color-text', '#000000');
        } else {
            root.style.setProperty('--color-text', '#FFFFFF');
        }
    }
}
